import { axiosInstance } from '../common/api';

export const getDashboardData = (pageNumber, pageSize, search) => {
  const url = `/dashboard?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => reject(err));
  });
};
